var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"container"},_vm._l((_vm.loadedPage.objects.shapes),function(shape,index){return _c('shape',{key:'shape'+index,ref:"shape",refInFor:true,attrs:{"id":index}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }